import Box from '@mui/material/Box'
import { useTheme } from '@mui/material'

export interface OffsetFromBottomDividerProps {
  bottomOffset?: number
}

export default function OffsetFromBottomDivider(
  props: OffsetFromBottomDividerProps
) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: props.bottomOffset ?? 120,
        width: '1px',
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.26)'
            : '#E4E4E4'
      }}
    />
  )
}
